export default "<div ng-show=\"commandEnabled\">\r\n    When Set Position is selected, click anywhere in the map to set a V-tag gateway there.\r\n</div>\r\n";